import _classCallCheck from "/Users/yashshelatkar/Documents/yash-shelatkar-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/yashshelatkar/Documents/yash-shelatkar-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
export var CircleDrawer = /*#__PURE__*/function () {
  function CircleDrawer() {
    _classCallCheck(this, CircleDrawer);
  }

  _createClass(CircleDrawer, [{
    key: "getSidesCount",
    value: function getSidesCount() {
      return 12;
    }
  }, {
    key: "draw",
    value: function draw(context, particle, radius) {
      context.arc(0, 0, radius, 0, Math.PI * 2, false);
    }
  }]);

  return CircleDrawer;
}();